// constants
import { DWEB_MAX_WIDTH, BASE_GUTTER_SPACE } from 'shared/styles/base';

const CONTENT_PADDING_DWEB = 60;
const PRODUCT_MARGIN_DWEB = 20 * 3;
const PRODUCT_PADDING_DWEB = 20;
const BIG_IMAGE_WIDTH_RATIO_DWEB = 0.65;
const SMALL_IMAGE_WIDTH_RATIO_DWEB = 0.3125;

const CONTENT_PADDING_MWEB = BASE_GUTTER_SPACE * 4;
const PRODUCT_PADDING_MWEB = BASE_GUTTER_SPACE * 2;
const BIG_IMAGE_WIDTH_RATIO_MWEB = 0.65;
const SMALL_IMAGE_WIDTH_RATIO_MWEB = 0.315;

export const calculateImageDimensions = (deviceWidth: number, isMobile: boolean) => {
  if (isMobile) {
    const contentWidth = deviceWidth - CONTENT_PADDING_MWEB;
    const productWidth = (contentWidth * 60) / 100;
    const productInnerWidth = productWidth - PRODUCT_PADDING_MWEB * 2;
    const bigImageWidth = BIG_IMAGE_WIDTH_RATIO_MWEB * productInnerWidth;
    const smallImageWidth = SMALL_IMAGE_WIDTH_RATIO_MWEB * productInnerWidth;

    return {
      productWidth,
      bigImageWidth,
      smallImageWidth,
      productPadding: PRODUCT_PADDING_MWEB,
    };
  } else {
    const contentWidth =
      (deviceWidth < DWEB_MAX_WIDTH ? deviceWidth : DWEB_MAX_WIDTH) - CONTENT_PADDING_DWEB;
    const productWidth = (contentWidth - PRODUCT_MARGIN_DWEB) / 4;
    const productInnerWidth = productWidth - PRODUCT_PADDING_DWEB * 2;
    const bigImageWidth = BIG_IMAGE_WIDTH_RATIO_DWEB * productInnerWidth;
    const smallImageWidth = SMALL_IMAGE_WIDTH_RATIO_DWEB * productInnerWidth;

    return {
      productWidth,
      bigImageWidth,
      smallImageWidth,
      productPadding: PRODUCT_PADDING_DWEB,
    };
  }
};
